/**
* @file 旅游包车 - 包车订单列表（包含旅游包车+专线包车）
* */
<template>
  <div id="charteredOrder">
    <el-tabs v-model="orderType" type="card" @tab-click="handleOrderTypeChange" class="order-type-tabs">
      <el-tab-pane name="tourism">
        <span slot="label"><i class="el-icon-truck" style="margin-right:4px"></i>旅游包车</span>
        <el-radio-group v-model="tabAction" style="margin-bottom: 10px;">
          <el-radio-button label="all">全部</el-radio-button>
          <el-radio-button v-for="item in $const.ORDERCHARTEREDSTATUS" :key="item.value" :label="item.value">
            {{ item.label }}
          </el-radio-button>
        </el-radio-group>
      </el-tab-pane>
      <el-tab-pane name="customize">
        <span slot="label"><i class="el-icon-s-promotion" style="margin-right:4px"></i>专线包车</span>
        <el-radio-group v-model="tabAction" style="margin-bottom: 10px;">
          <el-radio-button label="all">全部</el-radio-button>
          <el-radio-button v-for="item in $const.ORDERCHARTEREDSTATUS" :key="item.value" :label="item.value">
            {{ item.label }}
          </el-radio-button>
        </el-radio-group>
      </el-tab-pane>
    </el-tabs>

    <custom-table ref="customTable" :customOptions="customOptions" :columns="columns"
      hasChildren="passengerNum" loadChildrenId="id" :loadChildren="loadChildren"
      :excel-type="orderType === 'tourism' ? 'OrderChartered' : 'OrderIntercity'"
      :has-organization="orderType === 'customize'"
      labelWidth="135" style="height: 90%">
      <template slot="table-operation">
        <el-table-column label="操作" width="100" fixed="right">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" v-if="row.status === 5" @click="reassignmentClick(row)">派车</el-button>
            <el-button type="text" v-if="row.status == 10" @click="reassignmentClick(row)">改派</el-button>
            <el-button type="text" v-if="row.status === 5 || row.status === 1 || row.status === 10"
              @click="cancelClick(row)">退票
            </el-button>
            <el-button type="text" v-if="row.status === 45 || row.status === 60 || (row.status >= 15 && row.status <= 40)" @click="orderDetailClick(row)">详情</el-button>
            <span v-if="row.status !== 5 && row.status !== 1 && row.status != 10 && row.status !== 45 && row.status !== 60 && !(row.status >= 15 && row.status <= 40)" style="color:#999">-</span>
          </div>
        </el-table-column>
      </template>

      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">{{
          row.created | filterTime("YYYY-MM-DD HH:mm")
        }}</template>
        <template v-else-if="item.prop === 'schedulingTime'">{{
          row.schedulingTime | filterTime("MM-DD　HH:mm")
        }}</template>
        <template v-else-if="item.prop === 'finishTime'">{{
          row.finishTime | filterTime("YYYY-MM-DD HH:mm")
        }}</template>
        <template v-else-if="item.prop === 'orderNo'">
          <span class="link" @click.stop="orderDetailClick(row)" @dblclick="$utils.dblclickCopy">{{ row.orderNo }}</span>
        </template>
        <template v-else-if="item.prop === 'passengerNum'">
          {{ row.passengerNum }}
          <el-tag v-if="row.passengerNum > 1 && !row.hide && row.ticketRestrictions == 2" effect="plain" type="success"
            style="margin-left: 8px; border: 1px solid #008080; color: #008080; cursor: pointer;"
            @click="handleConnectionSearch(row, true)">查看</el-tag>
          <el-tag v-if="row.passengerNum > 1 && row.hide" type="info" style="margin-left: 8px; cursor: pointer"
            @click="handleConnectionSearch(row, false)">收起</el-tag>
        </template>
        <template v-else-if="item.prop === 'retreatFee'">
          <template v-if="row.status === 60 || row.isTicketChanging === 1">
            <div v-if="row.status === 60">
              <span class="util-money" v-if="row.retreatFee || row.retreatFee === 0">￥{{ row.retreatFee }}</span>
              <span class="util-money" v-if="!row.retreatFee && row.retreatFee !== 0">￥0</span>
              {{ row.refundProportion }}
            </div>
            <div v-if="row.isTicketChanging === 1">
              <span class="util-money" v-if="row.ticketChangingFee || row.ticketChangingFee === 0">￥{{
                row.ticketChangingFee }}</span>
              <span class="util-money" v-if="!row.ticketChangingFee && row.ticketChangingFee !== 0">￥0</span>
              {{ row.ticketChangingProportion ? "(" + row.ticketChangingProportion + "%改签费率)" : "(无改签费)" }}
            </div>
          </template>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'status'">
          <el-tag :type="getOrderStatusType(row.status)" size="mini" style="margin-right:4px">{{ row.status | filterOrderCharteredStatus }}</el-tag>
          <el-tooltip placement="right" v-if="row.beyondFeeStatus == 2">
            <div slot="content">
              <div v-if="row.beyondCharteredTimeFee && row.beyondCharteredMileFee">
                有￥{{ row.beyondCharteredTimeFee }}超时费、￥{{ row.beyondCharteredMileFee }}超里程费待付</div>
              <div v-else>
                <div v-if="row.beyondCharteredTimeFee">有￥{{ row.beyondCharteredTimeFee }}超时费待付</div>
                <div v-if="row.beyondCharteredMileFee">有￥{{ row.beyondCharteredMileFee }}超里程费待付</div>
              </div>
            </div>
            <i class="el-icon-warning" style="color:#f15221"></i>
          </el-tooltip>
        </template>
        <template v-else-if="item.prop === 'startStationName'">
          <div>{{ row.startStationName }}</div>
          <div style="color:#999">{{ row.startDetailAddress }}</div>
        </template>
        <template v-else-if="item.prop === 'endStationName'">
          <div>{{ row.endStationName }}</div>
          <div style="color:#999">{{ row.endDetailAddress }}</div>
        </template>
        <template v-else-if="item.prop === 'charterName'">
          <div>{{ row.charterName }} ({{ row.charteredVehicleSeat }}座)</div>
          <div style="color:#999">￥{{ row.baseFee }}</div>
        </template>
        <template v-else-if="item.prop === 'charterDay'">{{ row.charterDay }}天</template>
        <template v-else-if="item.prop === 'channelAlias'">
          <el-tag type="info" size="mini" effect="plain">{{ row[item.prop] | filterConst("CHANNELALIAS") }}</el-tag>
        </template>
        <template v-else-if="item.prop === 'licenseNo'">
          <span style="color: #999" v-if="row.status === 5">待指派</span>
          <template v-else>
            <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
            <span v-if="row.vehicleSeat" style="margin-left: 4px;">{{ row.vehicleSeat }}座</span>
            <span v-if="!row.licenseNo && !row.vehicleSeat">-</span>
          </template>
        </template>
        <template v-else-if="item.prop === 'driverName'">
          <span style="color: #999" v-if="row.status === 5">待指派</span>
          <span v-if="row.status !== 5">{{ row.driverName ? row.driverName : "-" }}</span>
        </template>
        <template v-else-if="item.prop === 'driverPhone'">
          <span style="color: #999" v-if="row.status === 5">待指派</span>
          <span v-if="row.status !== 5">{{ row.driverPhone ? row.driverPhone : "-" }}</span>
        </template>
        <template v-else-if="item.prop === 'realFee'">
          <template v-if="row.realFee || row.realFee === 0">
            <span class="util-money">¥{{ row.realFee }}</span>
            <span v-if="row.couponFee">(优惠券<span class="util-money-minus">-{{ row.couponFee }}</span>)</span>
          </template>
          <span v-if="!row.realFee && row.realFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'score'">
          <el-rate v-model="row.score" disabled></el-rate>
        </template>
        <template v-else-if="item.prop === 'customerPhone'">
          <div>{{ row.customerPhone }}</div>
          <el-popover v-if="row.customerName && orderType === 'customize'" placement="top" title="实名信息" trigger="click">
            <div slot="reference" style="color:#0066FF;cursor: pointer;">查看实名信息</div>
            <div>乘客姓名：{{ row.customerName }}</div>
            <div>身份证号码：{{ row.idCard }}</div>
          </el-popover>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <orderCharteredVehicle :visible.sync="reassignmentVisible" :order.sync="order" @confirm="$refs.customTable.listFn()">
    </orderCharteredVehicle>

    <!-- 退票对话框 -->
    <el-dialog title="订单退票" :visible.sync="refundState" width="380px" @close="refundFee = null">
      <p class="tips">说明：退票手续费不能大于乘客已付的基础费用</p>
      <div class="cancel-money" style="padding-top: 20px">
        <div class="cancel-money-title">实际支付</div>
        <div class="util-money">￥{{ order.realFee }}</div>
      </div>
      <div class="cancel-money">
        <div class="cancel-money-title" style="line-height:28px">退票手续费</div>
        <div>
          <el-input v-model="refundFee"
            @input="refundFee = refundFee.replace(/^0[\d]/g, '0').replace(/(\d\d{0,6}\.?\d{0,2})?.*/g, '$1').replace(/^[1-9][0-9]{7,}/g, '9999999')"
            placeholder="请输入要扣除的退票费">
            <template #append>元</template>
          </el-input>
        </div>
      </div>
      <div class="cancel-money" v-if="refundFee !== null && refundFee !== ''">
        <div class="cancel-money-title" style="color:#67C23A">预计退款</div>
        <div class="util-money" style="color:#67C23A">￥{{ computedRefundAmount }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancelConfirm" :loading="loading">确 认</el-button>
        <el-button @click="refundState = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 订单详情抽屉 -->
    <el-drawer :visible.sync="detailVisible" title="包车订单详情" size="500px" :with-header="true">
      <div style="padding: 20px;" v-if="detailOrder">
        <el-descriptions :column="1" border size="medium">
          <el-descriptions-item label="订单号">{{ detailOrder.orderNo }}</el-descriptions-item>
          <el-descriptions-item label="订单状态">{{ detailOrder.status | filterOrderCharteredStatus }}</el-descriptions-item>
          <el-descriptions-item label="机构名称">{{ detailOrder.organizationName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="下单渠道">{{ detailOrder.channelAlias | filterConst("CHANNELALIAS") }}</el-descriptions-item>
          <el-descriptions-item label="下单时间">{{ detailOrder.created | filterTime("YYYY-MM-DD HH:mm") }}</el-descriptions-item>
          <el-descriptions-item label="出发时间">{{ detailOrder.schedulingTime | filterTime("YYYY-MM-DD HH:mm") }}</el-descriptions-item>
          <el-descriptions-item label="完成/取消时间">{{ detailOrder.finishTime | filterTime("YYYY-MM-DD HH:mm") }}</el-descriptions-item>
          <el-descriptions-item label="出发地">
            <div>{{ detailOrder.startStationName }}</div>
            <div style="color:#999">{{ detailOrder.startDetailAddress }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="目的地">
            <div>{{ detailOrder.endStationName }}</div>
            <div style="color:#999">{{ detailOrder.endDetailAddress }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ detailOrder.customerPhone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="所选套餐">{{ detailOrder.charterName }} ({{ detailOrder.charteredVehicleSeat }}座)</el-descriptions-item>
          <el-descriptions-item label="包车天数">{{ detailOrder.charterDay }}天</el-descriptions-item>
          <el-descriptions-item label="实际支付">{{ detailOrder.realFee != null ? '￥' + detailOrder.realFee : '-' }}</el-descriptions-item>
          <el-descriptions-item label="退票费用">{{ detailOrder.retreatFee != null ? '￥' + detailOrder.retreatFee : '-' }}</el-descriptions-item>
          <el-descriptions-item label="车辆号牌">{{ detailOrder.licenseNo || '-' }}</el-descriptions-item>
          <el-descriptions-item label="车辆编号">{{ detailOrder.vehicleNo || '-' }}</el-descriptions-item>
          <el-descriptions-item label="司机姓名">{{ detailOrder.driverName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="司机电话">{{ detailOrder.driverPhone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="下单城市">{{ detailOrder.orderLocationCity || '-' }}</el-descriptions-item>
          <el-descriptions-item label="下单省份">{{ detailOrder.orderLocationProvince || '-' }}</el-descriptions-item>
          <el-descriptions-item label="下单国家">{{ detailOrder.orderLocationCountry || '-' }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import orderCharteredVehicle from '../order/chartered/orderCharteredVehicle';
export default {
  name: "charteredOrder",
  components: { orderCharteredVehicle },
  data() {
    return {
      orderType: 'tourism',
      tabAction: "all",
      loading: false,
      refundFee: null,
      refundState: false,
      detailVisible: false,
      detailOrder: null,
      customOptions: {
        url: "/api/v1/manage/order/chartered",
        params: {
          page: 1,
          size: 20,
        },
        search: [
          { type: "input", field: "orderNo", name: "订单号", value: "" },
          { type: "input", field: "startStationName", name: "出发地", value: "" },
          { type: "input", field: "endStationName", name: "目的地", value: "" },
          { type: "input", field: "customerPhone", name: "联系电话", value: "" },
          { type: "input", field: "driverName", name: "司机姓名", value: "" },
          { type: "input", field: "driverPhone", name: "司机电话", value: "" },
          { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
          { type: "input", field: "vehicleNo", name: "车辆编号", value: "" },
          { type: "datetime", field: "time", name: "下单时间", value: [] },
          { type: "datetime", field: "schedulingTime", dateProp: { start: "schedulingStartTime", end: "schedulingEndTime" }, name: "出发时间", value: [] },
          { type: "datetime", field: "finishTime", dateProp: { start: "finishStartTime", end: "finishEndTime" }, name: "完成/取消时间", value: [] },
          {
            type: "select", field: "channelAlias", name: "下单渠道", value: null,
            option: [
              { value: "channel_wechat", label: "微信小程序" },
              { value: "system_order", label: "平台代下" },
              { value: "channel_driver_order", label: "司机代下" },
              { value: "channel_alipay", label: "支付宝" },
            ],
          },
          {
            type: "select", field: "createdOrFinishTimeSort", name: "数据排序", value: null,
            option: [
              { value: 2, label: "下单时间↓" },
              { value: 1, label: "下单时间↑" },
              { value: 4, label: "完成时间↓" },
              { value: 3, label: "完成时间↑" },
            ],
          },
          {
            type: "select", field: "score", name: "订单评分", value: null,
            option: [
              { value: 1, label: "1星" },
              { value: 2, label: "2星" },
              { value: 3, label: "3星" },
              { value: 4, label: "4星" },
              { value: 5, label: "5星" },
              { value: '0', label: "未评价" },
            ],
          },
        ],
      },
      columns: [
        { prop: "orderNo", label: "订单号", width: 190 },
        { prop: "status", label: "订单状态", width: 80 },
        { prop: "organizationName", label: "机构名称", width: 120 },
        { prop: "channelAlias", label: "下单渠道", width: 100 },
        { prop: "created", label: "下单时间", width: 130 },
        { prop: "finishTime", label: "完成/取消时间", width: 130 },
        { prop: "startStationName", label: "出发地", minWidth: 200 },
        { prop: "endStationName", label: "目的地", minWidth: 200 },
        { prop: "schedulingTime", label: "出发时间", minWidth: 100 },
        { prop: "customerPhone", label: "联系电话", width: 110 },
        { prop: "charterName", label: "所选套餐", width: 150 },
        { prop: "charterDay", label: "包车天数", width: 80 },
        { prop: "realFee", label: "实际支付", width: 80 },
        { prop: "retreatFee", label: "退票费用", width: 80 },
        { prop: "licenseNo", label: "车辆号牌", width: 120 },
        { prop: "vehicleNo", label: "车辆编号", width: 120 },
        { prop: "driverName", label: "司机姓名", width: 70 },
        { prop: "driverPhone", label: "司机电话", width: 105 },
        { prop: "score", label: "评分", width: 130 },
      ],
      status: null,
      order: {},
      reassignmentVisible: false,
    };
  },
  computed: {
    computedRefundAmount() {
      if (this.order.realFee == null || this.refundFee === null || this.refundFee === '') return '-';
      let amount = (Number(this.order.realFee) - Number(this.refundFee)).toFixed(2);
      return amount >= 0 ? amount : '0.00';
    }
  },
  watch: {
    tabAction(val) {
      this.customOptions.params.page = 1;
      this.customOptions.params.status = val != "all" ? val : null;
      this.$refs.customTable.listFn();
    },
  },
  methods: {
    handleOrderTypeChange() {
      this.tabAction = 'all';
      this.customOptions.params.page = 1;
      this.customOptions.params.status = null;
      if (this.orderType === 'tourism') {
        this.customOptions.url = "/api/v1/manage/order/chartered";
      } else {
        this.customOptions.url = "/api/v1/manage/order/intercity";
      }
      this.$nextTick(() => {
        this.$refs.customTable.listFn();
      });
    },
    getOrderStatusType(status) {
      const map = { 1: '', 5: 'danger', 10: 'danger', 45: 'success', 60: 'info' };
      if (status >= 15 && status <= 40) return 'warning';
      return map[status] || 'info';
    },
    orderDetailClick(row) {
      this.detailOrder = row;
      this.detailVisible = true;
    },
    async handleConnectionSearch(row, bl) {
      if (bl) {
        let data = await this.$axios.get("/api/v1/manage/order/orderCustomer/customer/" + row.id);
        if (data && data.code === 1) {
          if (data.data.length == 0) {
            this.$message.warning("没有找到相关乘客");
          } else {
            let arr = [];
            for (const item of data.data) {
              if (item.isDefault == 1) continue;
              else { item.id = 9999999; arr.push(item); }
            }
            row.children = arr;
            row.hide = true;
            this.$refs.customTable.$refs.tableInner.toggleRowExpansion(row, bl);
          }
        } else {
          this.$message.error("查询错误");
        }
      } else {
        row.hide = false;
        this.$refs.customTable.$refs.tableInner.toggleRowExpansion(row, bl);
      }
    },
    async loadChildren(tree, treeNode, resolve) {
      let data = await this.$axios.get("/api/v1/manage/order/orderCustomer/customer/" + tree.id);
      if (data && data.code === 1) {
        if (data.data.length == 0) {
          this.$message.warning("没有找到相关乘客");
        } else {
          for (const item of data.data) {
            if (item.isDefault == 1) continue;
            else item.id = 9999999;
          }
          resolve(data.data);
        }
      } else {
        this.$message.error("查询错误");
        resolve([{ msg: "接口错误" }]);
      }
    },
    reassignmentClick(row) {
      this.order = row;
      this.reassignmentVisible = true;
    },
    async cancelClick(row) {
      this.order = row;
      this.refundState = true;
    },
    async cancelConfirm() {
      if (this.refundFee === null || this.refundFee === '') {
        this.$message.info('退票手续费不能为空');
        return;
      } else if (Number(this.refundFee) > Number(this.order.realFee)) {
        this.$message.info('退票手续费不能大于乘客已付的基础费用');
        return;
      } else if (Number(this.refundFee) < 0) {
        this.$message.info('退票手续费不能为负数');
        return;
      }
      this.loading = true;
      let data = await this.$axios.post("/api/v1/manage/order/chartered/cancel/" + this.order.orderId,
        { refundFee: this.refundFee });
      if (data && data.code === 1) {
        this.$message.success("已退票");
        this.refundFee = null;
        this.$refs.customTable.listFn();
      }
      this.loading = false;
      this.refundState = false;
    }
  },
  created() {
    if (this.$route.query.status) {
      this.customOptions.params.status = this.$route.query.status;
      this.tabAction = this.customOptions.params.status;
    }
  },
};
</script>

<style lang="less" scoped>
#charteredOrder {
  height: 100%;

  .order-type-tabs {
    margin-bottom: 0;
    /deep/ .el-tabs__header {
      margin-bottom: 0;
    }
    /deep/ .el-tabs__content {
      padding: 10px 0 0 0;
    }
  }

  .link {
    color: #409EFF;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  .cancel-money {
    display: flex;
    justify-content: space-between;

    .cancel-money-title {
      font-weight: 600;
    }
  }

  .cancel-money + .cancel-money {
    padding-top: 14px;
  }

  .tips {
    color: #999;
    font-size: 12px;
    margin-bottom: 8px;
  }
}
</style>
